import React from 'react';
import { Field } from 'react-final-form';
import FieldGroup from '../../../FieldGroup.jsx';

function TemplateForm() {
  return (
    <React.Fragment>
      <Field
        id="templateFormName"
        name="name"
        label="Title"
        placeholder="Title of the template"
        type="text"
        component={FieldGroup}
      />
      <Field
        id="templateFormUrl"
        name="url"
        label="URL"
        placeholder="https://"
        type="text"
        component={FieldGroup}
      />
    </React.Fragment>
  );
}

export default TemplateForm;
